














import { defineComponent, PropType } from '@vue/composition-api';
import * as Common from "../commons/common"

export default defineComponent({
  props: {
    labelColor: {
      type: String as PropType<string>,
      required: false,
      default: "#888",
    },
    direction: {
      type: Number as PropType<number>,
      required: false,
    }
  },
  setup(props, context){

    const DirectionEnum = Common.DirectionEnum;
    
    const directionChanged = (direction: any) => {
      context.emit("direction-changed", direction.value ? DirectionEnum.Horizon : DirectionEnum.Vertical);
    }

    return {
      DirectionEnum,
      directionChanged,
    };
  }
})
